export default [
  {
    prop: 'name',
    label: '管理员姓名',
    tooltip: true
  },
  {
    prop: 'account',
    label: '手机号',
    tooltip: true
  },
  {
    prop: 'role_name',
    label: '权限角色',
    tooltip: true
  },
  {
    prop: 'nickname',
    label: '创建人',
    tooltip: true
  },
  {
    prop: 'create_time',
    label: '创建时间',
    tooltip: true
  },
  {
    prop: 'action',
    width: '170px',
    label: '操作'
  }
]
